import {
  MorphemeMnemonicsPanelContentRoot,
  MorphemeMnemonicsMeaningViewTab,
} from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics._components.panel-content";

/**
 * The meaning tab as a read-only preview, for the grapheme preview sheet.
 *
 * Like {@link GraphemeMnemonicsMeaningReferenceSection} it takes no grapheme — it reads the
 * character from `MorphemePanelsContext`, so it only works inside that provider's subtree.
 *
 * Differs from the reference section in dropping the two affordances that belong to the full
 * page: the pronunciation tabs and the edit pencil. A preview is a look at the meaning, and the
 * sheet's "Open <glyph>" button is the way through to everything else.
 */
export function GraphemeMnemonicsMeaningPreviewSection() {
  return (
    <MorphemeMnemonicsPanelContentRoot hidePronunciationTabs>
      <MorphemeMnemonicsMeaningViewTab showEditButton={false} />
    </MorphemeMnemonicsPanelContentRoot>
  );
}
